import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['tab', 'panel', 'loadMore', 'activity'];

  static values = {
    recordsUrl: String,
    activityUrl: String,
    userId: Number,
  };

  connect() {
    this.offsets = {};
    this.loadedActivities = {};
  }

  // --- Tabs ---

  switchTab(event) {
    event.preventDefault();
    const tab = event.currentTarget.dataset.tab;

    // Update tab buttons
    this.tabTargets.forEach(t => {
      t.classList.toggle('mci-tab--active', t.dataset.tab === tab);
    });

    // Update panels
    this.panelTargets.forEach(p => {
      p.hidden = p.dataset.tab !== tab;
    });
  }

  // --- Load More ---

  async loadMore(event) {
    const button = event.currentTarget;
    const tab = button.dataset.tab;
    const listEl = this.element.querySelector(`[data-list="${tab}"]`);
    if (!listEl) return;

    const offset = this.offsets[tab] || listEl.childElementCount;
    button.disabled = true;
    button.textContent = 'Loading…';

    try {
      const url = `${this.recordsUrlValue}.json?tab=${tab}&offset=${offset}`;
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        let detail = `Status ${response.status}`;
        try { const d = await response.json(); detail = d.error || detail; } catch(_) {}
        throw new Error(detail);
      }

      const data = await response.json();

      data.html.forEach(itemHtml => {
        listEl.insertAdjacentHTML('beforeend', itemHtml);
      });

      this.offsets[tab] = offset + data.html.length;

      if (data.has_more) {
        button.disabled = false;
        button.textContent = 'Load more';
      } else {
        button.remove();
      }
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Retry';
      console.error('Load more failed:', error);
      button.textContent = 'Load more';
      console.error('Load more failed:', error);
    }
  }

  // --- Pass Activity ---

  async toggleActivity(event) {
    const button = event.currentTarget;
    const passId = button.dataset.passId;
    const activityEl = this.element.querySelector(
      `[data-mci-user-profile-target="activity"][data-pass-id="${passId}"]`
    );

    if (!activityEl) return;

    // If already visible, just collapse
    if (!activityEl.hidden) {
      activityEl.hidden = true;
      button.innerHTML = 'View attendance &darr;';
      return;
    }

    // If already loaded, just show
    if (this.loadedActivities[passId]) {
      activityEl.hidden = false;
      button.innerHTML = 'Hide attendance &uarr;';
      return;
    }

    // Fetch activity
    button.textContent = 'Loading…';
    button.disabled = true;

    try {
      const url = this.activityUrlValue.replace('PASS_ID', passId) + '.json';
      const response = await fetch(url, {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) {
        let detail = `Status ${response.status}`;
        try { const d = await response.json(); detail = d.error || detail; } catch(_) {
          try { detail = (await response.text()).substring(0, 100); } catch(_) {}
        }
        throw new Error(detail);
      }

      const data = await response.json();
      activityEl.innerHTML = data.html;
      activityEl.hidden = false;
      this.loadedActivities[passId] = true;

      button.innerHTML = 'Hide attendance &uarr;';
      button.disabled = false;
    } catch (error) {
      button.innerHTML = 'Retry &darr;';
      button.disabled = false;
      console.error('Activity load failed:', error);
    }
  }
}
